
import {quantityInput, phoneInputMask} from '../form/inputs'
import GLightbox from 'glightbox';

import {numberFormat} from "../helpers";
import validateDefaults from '../validateDefaults'

// import select2 from 'select2/dist/js/select2'

const _token = $('meta[name="csrf-token"]').attr('content');
const locale = $('html').attr('lang');


const deleteProductFromCart = () => {
    const $delete_product = $('[data-delete-product]');

    const cart__total__price = $('.cart__total__price');
    const cart__subtotal__price = $('.cart__subtotal__price');
    const cart__delivery = $('.cart__delivery');
    const credit__price = $('.credit__price');
    const rate_price = $('.cart__rate');

    $delete_product.on('click', function (e) {
        e.preventDefault();

        let id = $(this).attr('data-id');
        let url = $(this).attr('data-url');
        let translation = $(this).attr('data-price-translation');
        let creditTranslation = $('.credit__price').attr('data-price-translation');
        let delivery = $('#delivery__region').val();

        let credit;

        if ($('#credit').is(':checked')) {
            credit = 1;
        } else {
            credit = 0;
        }

        delay(function () {
            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: {
                    id: id,
                    credit: credit,
                    delivery: delivery,
                    _token: _token
                },
                success: function (result) {
                    if (result.count === 0) {
                        location.reload();
                    }
                    if (result.status === true) {
                        $(".cart__list_item[data-id=" + id + "]").remove();
                        $('.cart__count').html(result.count);
                        cart__subtotal__price.html(numberFormat(result.total, 0, '.', ' ') + ' ' + translation);
                        credit__price.html(numberFormat(result.rate, 2, '.', ' ') + ' ' + creditTranslation);
                        rate_price.html(numberFormat(result.credit, 2, '.', ' ') + ' ' + translation);
                        $('.cart__delivery').html(numberFormat(result.delivery, 0, '.', ' ') + ' ' + 'RON');

                        if (result.credit !== 0) {
                            cart__total__price.html(numberFormat(result.subTotal, 2, '.', ' ') + ' ' + translation);
                        } else {
                            cart__total__price.html(numberFormat(result.subTotal, 0, '.', ' ') + ' ' + translation);
                        }
                    }
                }
            });
        }, 200);
    });

};

const orderCartForm = () => {

    const $order__form = $('#order__form');
    const $submit_order_form = $('[data-submit-order-form]');
    const $form__col = $('.form__col');
    const $delivery__pickup = $('#delivery__pickup');
    const $delivery__home = $('#delivery__home');
    const $payment__credit = $('#payment__credit');
    const $credit = $('#credit');

    const $payment = $('[name="payment"]');
    const $delivery = $('[name="delivery"]');
    const delivery__region = $('#delivery__region');

    let form_order;

    form_order = $order__form.validate({
        // ignore: [],
        errorClass: "form__error",
        validClass: "has-value",
        errorElement: 'span',
        wrapper: false,
        onchange: false,
        rules: {
            order__name: {required: true, maxlength: 255},
            order__phone: {required: true, regexp: /(?:(\+40))(?:\s*\d){9}$/},
            order__email: {required: true, regexp: /(.+)@(.+)\.(.+)/i, maxlength: 255},
            delivery__region: {required: '#home[value="home"]:checked'},
            delivery__city: {required: '#home[value="home"]:checked'},
            delivery__address: {required: '#home[value="home"]:checked', maxlength: 255},
            terms__rules_order: {custom_required: true},
        },
        ...validateDefaults
    });

    $submit_order_form.on('click', function () {
        $submit_order_form.addClass('button__loading');

        delay(function () {
            const isValid = form_order.form();

            if (isValid) {
                const formData = Object.fromEntries(new URLSearchParams($order__form.serialize()));

                $.ajax({
                    url: `${locale}/order`,
                    type: "POST",
                    data: {
                        location: 2,
                        _token: _token,
                        ...formData
                    },
                    success: function (response) {
                        if (response.status === true) {
                            window.location.href = response.formUrl;
                        }

                        if (response.statusOrder === true) {
                            window.location.href = response.link;
                        }
                    },
                    error: function (error) {
                        $submit_order_form.removeClass('button__loading');

                        let response = error.responseJSON;

                        if (error.status === 422 && response && typeof response.response === 'object') {
                            const errors = response.response;

                            form_order.showErrors(errors);
                        } else {
                            console.error("Errors:", error);
                        }
                    }
                });
            } else {
                $submit_order_form.removeClass('button__loading');
                form_order.focusInvalid();
            }
        }, 100);
    });

    $payment.change(function () {
        if ($(this).is(':checked')) {
            let payment_type = $(this).val();
            if (payment_type === 'credit') {
                $payment__credit.addClass('show');
                let translation = $(this).attr('data-price-translation');
                let creditTranslation = $('.credit__price').attr('data-price-translation');
                let delivery = $('#delivery__region').val();
                let credit = 0;
                $('.rate_md').removeClass('d-none');

                if ($('#credit').is(':checked')) {
                    credit = 1;
                } else {
                    credit = 0;
                }

                $.ajax({
                    url: 'cart/credit',
                    type: "POST",
                    data: {
                        id: 0,
                        credit: credit,
                        delivery: delivery,
                        _token: _token
                    },
                    success: function (data) {
                        $('.cart__rate').html(numberFormat(data.credit, 2, '.', ' ') + ' ' + translation);
                        $('.credit__price').html(numberFormat(data.rate, 2, '.', ' ') + ' ' + creditTranslation);
                    }
                });
            } else {
                let translation = $('.quantity__input').attr('data-price-translation');
                let delivery = $('#delivery__region').val();

                $.ajax({
                    url: 'cart/credit',
                    type: "POST",
                    data: {
                        id: 1,
                        delivery: delivery,
                        _token: _token
                    },
                    success: function (data) {
                        $('.cart__delivery').html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);
                        $('.cart__total__price').html(numberFormat(data.total, 0, '.', ' ') + ' ' + translation);
                    }
                });

                $('.rate_md').addClass('d-none');
                $payment__credit.removeClass('show');
            }
        }
    });

    $delivery.change(function () {
        if ($(this).is(':checked')) {
            let payment_type = $(this).val();

            if (payment_type === 'pickup') {
                let translation = $('.select-trigger').attr('data-price-translation');
                let credit;

                if ($('#credit').is(':checked')) {
                    credit = 1;
                } else {
                    credit = 0;
                }

                $.ajax({
                    url: 'cart/delivery',
                    type: "POST",
                    data: {
                        id: 0,
                        credit: credit,
                        paymentType: payment_type,
                        _token: _token
                    },
                    success: function (data) {
                        $('.select-trigger').val("").trigger("change");
                        $('#delivery__address').val('');
                        $('.cart__delivery').html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);

                        if (data.credit != 0) {
                            $('.cart__total__price').html(numberFormat(data.subTotal, 2, '.', ' ') + ' ' + translation);
                        } else {
                            $('.cart__total__price').html(numberFormat(data.subTotal, 0, '.', ' ') + ' ' + translation);
                        }
                    }
                });

                $delivery__pickup.addClass('show');
                $delivery__home.removeClass('show');
            } else {
                $delivery__home.addClass('show');
                $delivery__pickup.removeClass('show');
            }
        }

    });

    $credit.change(function () {
        if ($(this).is(':checked')) {
            let translation = $('.select-trigger').attr('data-price-translation');
            let creditTranslation = $('.credit__price').attr('data-price-translation');
            let delivery = $('#delivery__region').val();

            $.ajax({
                url: 'cart/credit',
                type: "POST",
                data: {
                    id: 0,
                    delivery: delivery,
                    _token: _token
                },
                success: function (data) {
                    // $('.select-trigger').val("").trigger("change");
                    $('.cart__rate').html(numberFormat(data.credit, 2, '.', ' ') + ' ' + translation);
                    // $('.cart__delivery').html(numberFormat(data.delivery, 0, '.', ' ') + ' ' + translation);
                    $('.cart__total__price').html(numberFormat(data.total, 2, '.', ' ') + ' ' + translation);
                    $('.credit__price').html(numberFormat(data.rate, 2, '.', ' ') + ' ' + creditTranslation);
                }
            });
        }
    });

    const $message__block = $('#message__block');

    $(document).on('change', '#message__check',function () {
        if($(this).is(':checked')) {
            $message__block.removeClass('d-none');
        } else {
            $message__block.addClass('d-none');
        }
    });

    const product__material = GLightbox({
        selector: '.open__material'
    });

    $('.select-trigger').select2({
        minimumResultsForSearch: Infinity,
        // dropdownParent: $('.form__col')
    });

    delivery__region.on("select2:select", function (e) {
        e.preventDefault();

        let id = $(this).val();

        let selectedOption = $(this).find('option:selected');
        let zone = selectedOption.data('zone');

        $.ajax({
            url: 'cart/delivery-ro',
            type: "POST",
            data: {
                id: id,
                zone: zone,
                _token: _token
            },
            success: function (response) {
                let $citySelect = $('#delivery__city');
                let localities = response.localities;

                $citySelect.empty();

                $citySelect.append('<option value="">Select locality</option>');

                Object.entries(localities).forEach(function ([id, name]) {
                    $citySelect.append(`<option value="${name}">${name}</option>`);
                });

                $citySelect.prop('disabled', false);

                $('.cart__delivery').html(numberFormat(response.delivery, 0, '.', ' ') + ' ' + 'RON');

                $('.cart__total__price').html(numberFormat(response.subTotal, 0, '.', ' ') + ' ' + 'RON');
            }
        });
    });

};
jQuery(document).ready(function () {
    orderCartForm()

    deleteProductFromCart()

    quantityInput()

    phoneInputMask()
})
